import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu, MenubarItem } from '@criteria-labs/react'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useRunSpectralLint } from '../../workers/useRunSpectralLint'

export function RunMenu() {
  const runSpectralLint = useRunSpectralLint()

  return (
    <Dropdown>
      <DropdownButton as={MenubarItem}>Run</DropdownButton>
      <DropdownMenu anchor="bottom start" modal={false}>
        <DropdownItem onClick={runSpectralLint}>
          <MagnifyingGlassIcon />
          <DropdownLabel>Lint OpenAPI Files</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
